import React from 'react';
import { motion } from 'framer-motion';

const Legal = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="pt-16 lg:pt-20"
    >
      {/* Hero Section */}
      <section className="py-20 bg-gradient-to-br from-blue-900 to-blue-700 dark:from-blue-950 dark:to-blue-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ y: 50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            className="text-center text-white"
          >
            <h1 className="text-4xl md:text-5xl font-bold mb-6">
              Mentions Légales
            </h1>
          </motion.div>
        </div>
      </section>

      {/* Content */}
      <section className="py-20 bg-white dark:bg-gray-900">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ y: 50, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            viewport={{ once: true }}
            className="space-y-8 text-gray-700 dark:text-gray-300"
          >
            <div>
              <h2 className="text-2xl font-bold text-gray-800 dark:text-white mb-4">
                1. Éditeur du Site
              </h2>
              <p className="mb-4">
                <strong>Raison Sociale :</strong> M.A.M Consulting
              </p>
              <p className="mb-4">
                <strong>RCCM :</strong> CM-DLA-2024-01-A02710-10
              </p>
              <p className="mb-4">
                <strong>NIU :</strong> P098414427388S
              </p>
              <p className="mb-4">
                <strong>Adresse :</strong> Bonamoussadi, Bloc H42, BP 3123 Douala, Cameroun
              </p>
              <p className="mb-4">
                <strong>Téléphone :</strong> +237 699 187 929 / +237 650 363 478
              </p>
              <p className="mb-4">
                <strong>Email :</strong> contact@mam-consulting.biz
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-gray-800 dark:text-white mb-4">
                2. Hébergement
              </h2>
              <p className="mb-4">
                Ce site est hébergé par les serveurs cloud modernes garantissant une disponibilité optimale et une sécurité renforcée.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-gray-800 dark:text-white mb-4">
                3. Propriété Intellectuelle
              </h2>
              <p className="mb-4">
                Tous les contenus présents sur ce site (textes, images, logos, etc.) sont la propriété exclusive de M.A.M Consulting ou de ses partenaires et sont protégés par les lois relatives à la propriété intellectuelle. Toute reproduction, même partielle, est strictement interdite sans autorisation préalable écrite.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-gray-800 dark:text-white mb-4">
                4. Responsabilité
              </h2>
              <p className="mb-4">
                M.A.M Consulting met tout en œuvre pour assurer l'exactitude et la disponibilité des informations publiées sur ce site. Cependant, la société ne peut être tenue responsable des erreurs, omissions ou interruptions du service. Les utilisateurs consultent ce site à leurs risques et périls.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-gray-800 dark:text-white mb-4">
                5. Limitations de Responsabilité
              </h2>
              <p className="mb-4">
                M.A.M Consulting ne sera pas responsable des dommages directs, indirects, accessoires ou consécutifs résultant de l'utilisation ou de l'impossibilité d'utiliser ce site ou les services proposés.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-gray-800 dark:text-white mb-4">
                6. Liens Externes
              </h2>
              <p className="mb-4">
                Ce site peut contenir des liens vers des sites externes. M.A.M Consulting n'est pas responsable du contenu de ces sites tiers et ne peut garantir leur disponibilité ou leur conformité légale.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-gray-800 dark:text-white mb-4">
                7. Droit Applicable
              </h2>
              <p className="mb-4">
                Ces mentions légales sont régies par la loi camerounaise. Tout litige sera soumis à la juridiction compétente du Cameroun.
              </p>
            </div>
          </motion.div>
        </div>
      </section>
    </motion.div>
  );
};

export default Legal;